import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { ConfigService } from '../../../@vex/services/config.service';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceGuard  {
  constructor(
    private router: Router,
    public authService: AuthService,
    private configService: ConfigService,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.authService.currentUserValue$().pipe(
      map(user => {
        // Si le mode maintenance n'est pas activé, autoriser l'accès
        if (!this.configService.env.maintenanceMode) {
          return true;
        }

        // Les utilisateurs Predik peuvent accéder même en maintenance
        if (user && user.isPredik) {
          return true;
        }

        // Rediriger vers la page de maintenance
        this.router.navigate(['/maintenance']).then();
        return false;
      }),
      catchError((err, caught) => {
        return of(false);
      }),
    );
  }
}
